import { render, staticRenderFns } from "./VatInfo.vue?vue&type=template&id=4c19e2b0&scoped=true&"
import script from "./VatInfo.vue?vue&type=script&lang=js&"
export * from "./VatInfo.vue?vue&type=script&lang=js&"
import style0 from "./VatInfo.vue?vue&type=style&index=0&id=4c19e2b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c19e2b0",
  null
  
)

/* custom blocks */
import block0 from "./VatInfo.vue?vue&type=custom&index=0&blockType=messages"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VCard,VCardText,VIcon,VMenu})
